var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUploadCloud = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 32.0001L24.0005 24.0001L16.0005 32.0001",
    stroke: "#172B4D",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.0001V42.0001",
    stroke: "#172B4D",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7799 36.7801C42.7306 35.7166 44.2716 34.0339 45.1597 31.9973C46.0477 29.9608 46.2323 27.6866 45.6843 25.5335C45.1363 23.3804 43.8869 21.4711 42.1333 20.107C40.3796 18.7429 38.2216 18.0016 35.9999 18.0001H33.4799C32.8746 15.6586 31.7462 13.4848 30.1798 11.6421C28.6134 9.79939 26.6496 8.33579 24.4361 7.3613C22.2226 6.38682 19.817 5.92681 17.4002 6.01585C14.9833 6.1049 12.6181 6.74069 10.4823 7.87542C8.34649 9.01015 6.49574 10.6143 5.06916 12.5673C3.64259 14.5202 2.6773 16.7712 2.24588 19.1509C1.81446 21.5306 1.92813 23.9772 2.57835 26.3066C3.22856 28.6361 4.3984 30.7878 5.99992 32.6001",
    stroke: "#172B4D",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 32.0001L24.0005 24.0001L16.0005 32.0001",
    stroke: "#172B4D",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload-cloud.e1e63945.svg";
export { ForwardRef as ReactComponent };